/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import { AddUserForm } from './components/AddUser.form'

/**
 *     Import
 *     - CSS
 */
import './styles/AddUser.css'

export default class AddUser extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    goUserList = () => this.props.history.push('/agent-admin/manage-agency')

    render() {

        if (this.props.successState) {
            this.goUserList()
        }

        return (
            <div className="addUser">
                <HeaderContainer
                    className="addUser__header"
                    fullwidth={true}
                    titles={['Add New User']}
                    back={true}
                    backAction={() =>  this.props.history.goBack()}
                />

                <Container className="addUser__form" fullwidth={false}>
                    <AddUserForm
                        errorState={this.props.errorState}
                        addNewUserTrigger={this.props.addNewUserTrigger}
                        goBack={this.goUserList}
                    />
                </Container>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/ManageAgency/AddUser.tsx